import { Box, Grid2, Typography } from '@mui/material'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Grid_Gap } from '../../shared/constants'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'
import { GridChildren } from '../../shared/utils/LingtBlueContainer'
import TabsComponent from '../../shared/components/Tabs/TabComponent'
import TabPanel from '../../shared/components/Tabs/TabPanel'
import useTabs from '../../shared/hook/useTabs'
import useAuthStore from '../../store/useAuthStore'
import { useTrainerCourses, useTrainerOnlineCourse } from '../../assets/api/useTrainerGetApi'
import CurrentClassCard from '../../shared/components/trainer.js/CurrentClassCard'


const RenderCourses = ({ courses, isLoading }) => {
    const completedCourses = courses?.filter(
        (item) => item.course_status === "Completed Class"
    );

    const ongoingCourses = courses?.filter(
        (item) => item.course_status === "Ongoing Class"
    );

    const upcomingCourses = courses?.filter(
        (item) => item.course_status === "Upcoming Class"
    );

    return (
        <>
            <NormalContainerWithHeader headerText={"Ongoing Courses"}>
                <Grid2 container spacing={Grid_Gap}>
                    {!isLoading && (
                        ongoingCourses?.length > 0 ? (
                            ongoingCourses.map((item, index) => (
                                <GridChildren index={index} key={index}>
                                    <CurrentClassCard item={item} />
                                </GridChildren>
                            ))
                        ) : (
                            <Typography variant='body2'>No Ongoing Courses</Typography>
                        )

                    )}
                    {
                        isLoading && (
                            [...Array(2)].map((_, index) => (
                                <GridChildren index={index} key={index}>
                                    <SkeletonCom />
                                </GridChildren>
                            ))
                        )
                    }
                </Grid2>
            </NormalContainerWithHeader>
            <CustomDivider orientation='horizontal' />
            <NormalContainerWithHeader headerText={"Upcoming Courses"} isGrid={false}>

                <Grid2 container spacing={Grid_Gap}>

                    {!isLoading && (
                        upcomingCourses?.length > 0 ? (
                            upcomingCourses.map((item, index) => (
                                <GridChildren index={index} key={index}>
                                    <CurrentClassCard item={item} />
                                </GridChildren>
                            ))
                        ) : (
                            <Typography variant='body2'>No Upcoming  Courses</Typography>
                        )

                    )}
                    {
                        isLoading && (
                            [...Array(2)].map((_, index) => (
                                <GridChildren index={index} key={index}>
                                    <SkeletonCom />
                                </GridChildren>
                            ))
                        )
                    }
                </Grid2>
            </NormalContainerWithHeader>
            <CustomDivider orientation='horizontal' />
            <NormalContainerWithHeader headerText={"Completed Courses"}>
                <Grid2 container spacing={Grid_Gap}>
                    {!isLoading && (
                        completedCourses?.length > 0 ? (
                            completedCourses.map((item, index) => (
                                <GridChildren index={index} key={index}>
                                    <CurrentClassCard item={item} />
                                </GridChildren>
                            ))
                        ) : (
                            <Typography variant='body2'>No Completed Courses</Typography>
                        )

                    )}
                    {
                        isLoading && (
                            [...Array(2)].map((_, index) => (
                                <GridChildren index={index} key={index}>
                                    <SkeletonCom />
                                </GridChildren>
                            ))
                        )
                    }
                </Grid2>
            </NormalContainerWithHeader>
        </>
    )
}



const TrainerMyCourses = () => {
    const { value, handleChange } = useTabs(0);
    const { user } = useAuthStore()
    const { data: trainerOfflineCourses, isLoading: isOfflineCoursesLoading } = useTrainerCourses(user?.id);
    const { data: trainerOnlineCourses, isLoading: isOnlineCoursesLoading } = useTrainerOnlineCourse({ trainer_id: user?.id });
   
  
    const tabsData = [
        { label: "Offline Classes", component: <RenderCourses courses={trainerOfflineCourses?.data} isLoading={isOfflineCoursesLoading} /> },
        { label: "Online Classes", component: <RenderCourses courses={trainerOnlineCourses?.data} isLoading={isOnlineCoursesLoading} /> }
    ];
  
    return (
        <Box>

            <CustomDivider orientation='horizontal' />

            <CustomDivider orientation='horizontal' />

            <TabsComponent tabs={tabsData} value={value} onChange={handleChange} />
            {tabsData.map((tab, index) => (
                <TabPanel key={index} value={value} index={index}>
                    {tab.component}
                </TabPanel>
            ))}

        </Box>


    )
}

export default TrainerMyCourses 